import type { exportacao as pt } from '../pt-BR/exportacao';
import type { Traducao } from '../Traducao';

export const exportacao = {
  explicacao:
    'El archivo incluye a quien quiere recibir el obsequio en Brasil, con la talla y la dirección de entrega, el total por talla, y en otra hoja a quien recibe el neceser en el extranjero. Los participantes excluidos no se incluyen.',
  usoInterno: 'Incluir la hoja "Uso interno" con la matrícula',
  usoInternoHint: 'No envíe esta hoja al proveedor.',
  baixar: 'Descargar',
  baixado: 'Archivo generado.',
  participantes: { botao: 'Exportar participantes' },
} as const satisfies Traducao<typeof pt>;
